import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';
import Seo, { siteSchema, webSiteSchema } from '@/components/base/Seo';
import Hero from './components/Hero';
import Features from './components/Features';
import HotMangas from './components/HotMangas';
import LatestUpdates from './components/LatestUpdates';
import Calendar from './components/Calendar';
import CategoriesSection from './components/CategoriesSection';
import Community from './components/Community';
import ArticlesPreview from './components/ArticlesPreview';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '漫画更新提醒是如何工作的？',
      acceptedAnswer: { '@type': 'Answer', text: '订阅关注的漫画作品后，最新话更新时漫迹会第一时间提醒，无需每天手动刷新。' },
    },
    {
      '@type': 'Question',
      name: '如何查看连载进度？',
      acceptedAnswer: { '@type': 'Answer', text: '进入漫画详情即可查看连载状态、总话数、最新章节与更新频率。' },
    },
    {
      '@type': 'Question',
      name: '更新日历有什么用？',
      acceptedAnswer: { '@type': 'Answer', text: '更新日历按星期展示每周各作品的更新安排，帮你提前规划追更时间。' },
    },
  ],
};

export default function Home() {
  return (
    <>
      <Seo
        title="漫迹漫画追更工具官网 - 漫画更新提醒 / 最新话推送 / 连载进度查询"
        description="漫迹是专业的漫画追更工具，提供漫画更新提醒、最新话推送与连载进度查询，还有漫画更新日历和追更社区，追更不迷路，精彩不错过。"
        path="/"
        jsonLd={[siteSchema, webSiteSchema, faqSchema]}
      />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HotMangas />
        <LatestUpdates />
        <Calendar />
        <CategoriesSection />
        <Community />
        <ArticlesPreview />
        <FAQ />
        <CTA />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}